module.exports = __webpack_public_path__ + "static/video-desk-796d4b550ecd83339db8c8203ef17aea.mp4";